import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typography from "@mui/material/Typography";
import AOS from "aos";
import "aos/dist/aos.css";
import Link from "@mui/material/Link";
import BottomCheckOutNav from "../components/BottomCheckOutNav";

const restaurantName = process.env.REACT_APP_RESTAURANT_NAME;
const seniorlivingName = process.env.REACT_APP_SITE_NAME;
const emailAddress = process.env.REACT_APP_CONTACT_US_EMAIL;
const phoneNumber = process.env.REACT_APP_CONTACT_US_PHONE;
const googleMaps = process.env.REACT_APP_GOO_GL_MAPS;
const restaurantAddress = process.env.REACT_APP_RESTAURANT_ADDRESS;
const restaurantURL = process.env.REACT_APP_SITE;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const buttonText = process.env.REACT_APP_BUTTON_TEXT;
const textHighlight = process.env.REACT_APP_TEXT_HIGHLIGHT;
const enableSL = parseInt(process.env.REACT_APP_ENABLE_SL);

export const PrivacyPolicySL = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);

  return (
    <div
      data-aos-easing="ease-in-out"
      data-aos-delay="0"
      data-aos="fade-top"
      style={{
        backgroundColor: "whitesmoke",
        minHeight: "100vh",
      }}
    >
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Privacy Policy - {`${restaurantName}`}</title>
          <link rel="canonical" href={`${restaurantURL}sl-privacy-policy`} />
          <meta
            name="description"
            content="Read our Privacy Policy to understand how we collect, use, and protect your personal information. Your privacy matters to us."
          />
          <meta
            name="keywords"
            content="Privacy Policy, data protection, personal information, user privacy, data collection"
          />
          <meta name="author" content={`${restaurantName}`} />
          <meta
            property="og:title"
            content={`Privacy Policy - ${restaurantName}`}
          />
          <meta
            property="og:description"
            content="Learn more about our commitment to protecting your personal information in our Privacy Policy."
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`${restaurantURL}sl-privacy-policy`}
          />
          <meta property="og:image" content={`${siteMedSrc}logo.webp`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={`Privacy Policy - ${restaurantName}`}
          />
          <meta
            name="twitter:description"
            content="Understand how we safeguard your privacy in our detailed Privacy Policy."
          />
          <meta name="twitter:image" content={`${siteMedSrc}logo.webp`} />
        </Helmet>
      </HelmetProvider>
      <div
        className="HeaderImg"
        style={{
          backgroundImage: `url(${siteMedSrc}background.webp)`,
          color: buttonText,
        }}
      >
        <Container>
          <Row>
            <col className="whitespace"></col>
            <Col xs={12}>
              <h2 className="center" style={{ color: textHighlight }}>
                Privacy Policy
              </h2>
            </Col>
            <Col xs={10} className="center">
              <h5 className="white"></h5>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="privacy">
        <Row className="left">
          <Col xs={12}>
            <h5 className="MuiContainer-root">Last Updated: May 26, 2025</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              {restaurantName} (“{seniorlivingName},” “<strong>we</strong>,” “
              <strong>our</strong>,” or “<strong>us</strong>”) respects your
              privacy and is committed to protecting it through our compliance
              with this privacy policy. This privacy policy explains our
              policies and procedures regarding the collection, use, disclosure,
              and security of certain information we receive, focusing on
              information considered “personal information,” including
              information by which you may be personally identified. We
              sincerely hope that we will develop a trusting and long-lasting
              relationship with you by explaining our practices for handling
              information.
            </Typography>
            <h5>Data Minimization</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We take every reasonable step to limit the volume of your personal
              information that we process to what is reasonably necessary;
              provided, however, we do not have complete control over the type
              of personal information that an Organization may request or
              require.
            </Typography>
            <h5>
              We do not Engage in Automated Decision-making without Human
              Intervention
            </h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We do not use automated decision-making without human
              intervention, including profiling, in a way that produces legal
              effects concerning you or otherwise significantly affects you.
            </Typography>
            <h5>Use of Cookies and Other Tracking Technologies</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              The technologies we use for automatic data collection may include:
            </Typography>
            <ul style={{ marginLeft: "2rem" }}>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  <strong>Cookies (or browser cookies).</strong> A cookie is a
                  small file placed on the hard drive of your computer. You may
                  refuse to accept browser cookies by activating the appropriate
                  setting on your browser. However, if you select this setting,
                  you may be unable to access certain parts of the site. Unless
                  you have adjusted your browser setting so that it will refuse
                  cookies, our system will issue cookies when you direct your
                  browser to the site.
                </Typography>
              </li>
            </ul>
            <h5>Do Not Track Policy</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              Your web browser may offer you a “Do Not Track” option, which
              allows you to signal to operators of websites and web applications
              and services (including behavioral advertising services) that you
              do not wish such operators to track certain of your online
              activities over time and across different websites. We do not
              honor any web browser “Do Not Track” signals or other mechanisms
              that provide you with the ability to exercise choice regarding the
              collection of personally identifiable information about your
              online activities over time and across third-party websites or
              online services. At present, no universally accepted standards
              exist on how companies should respond to do-not-track signals. In
              the event a final universally accepted standard is established, we
              will assess and provide an appropriate response to these signals.
            </Typography>

            <h5>Third-party Responsibilities and Services</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We may use or partner with other third-party companies, agents or
              contractors for various purposes in connection with our business
              and operations (<strong>“Service Providers”</strong>), including,
              the processing of donations and other payments, the marketing and
              growth of our business, and the performance of services on our
              behalf, such as gathering and analyzing information and the
              provision of services to you. In the course of performing these
              responsibilities and providing such services, these other
              companies may have access to your information. We may also share
              information, including your information, with these Services
              Providers in order to enable them to perform these
              responsibilities and to provide these services. These Services
              Providers may have adopted their own privacy policies, which are
              not subject to control by {seniorlivingName}. You should always
              review the policies of these Service Providers to make sure that
              you are comfortable with the ways in which they collect, use,
              maintain, protect and disclose your information. We do not list
              our current Service Providers because they change from time to
              time.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              The Service Providers may also transmit cookies to your computer
              or device when you click on ads that appear on or through the
              Service.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              As a convenience to you, we may or may in the future also provide
              links to other third-parties from within our Service. If you click
              on one of these links, you will be redirected to that
              third-party’s site (via affiliate cookies) and such third party
              may also transmit cookies to you. We do not have any control over
              that or how they collect, use, maintain, protect and disclose your
              information. Please be aware that cookies placed by third parties
              may continue to track your activities online even after you are no
              longer using any of the {seniorlivingName} Services, and those
              third parties may not honor “Do Not Track” requests you have set
              using your web browser.
            </Typography>
            <h5>Facebook Pixel</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              The Facebook pixel is an analytics tool that allows us to measure
              the effectiveness of our advertisements by understanding the
              actions visitors take on the site. We use pixel data to:
            </Typography>
            <ul style={{ marginLeft: "2rem" }}>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Make sure our advertisements are being shown to the right
                  people
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Build advertising audience
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Unlock additional Facebook advertising tools
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  When someone visits the site, and acts (like making a
                  donation) the Facebook pixel is triggered and reports this
                  action. This way we will be able to reach out to that person
                  again through future Facebook advertising.
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" color="text.primary" paragraph>
              More information about Facebook’s privacy practices can be found
              at{" "}
              <Link
                href="https://www.facebook.com/privacy/policy"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                Facebook Privacy Policy
              </Link>
              .
            </Typography>
            <h5>LinkedIn Insight Tags</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We use the “LinkedIn Insight Tag” on the site. It helps us with
              in-depth campaign reporting and insights about our website
              visitors. It can also be used to track conversions, retarget
              website visitors, and unlock additional insights about members
              interacting with our ads on LinkedIn.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              The LinkedIn Insight Tag enables the collection of data regarding
              members’ visits to our website, including the URL, referrer, IP
              address, device and browser characteristics (User Agent), and
              timestamp. This data is encrypted, the IP addresses are truncated,
              and members’ direct identifiers are removed within seven days in
              order to make the data pseudonymous. This remaining, pseudonymized
              data is then deleted within 90 days.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              LinkedIn does not share personal data with us, it only provides
              aggregated reports about the website audience and ad performance.
              LinkedIn also provides retargeting for website visitors, enabling
              us to show personalized ads off our website by using this data,
              but without identifying the member. LinkedIn members can control
              the use of their personal data for advertising purposes through
              their account settings.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              More information about LinkedIn’s privacy practices can be found
              at{" "}
              <Link
                href="https://www.linkedin.com/legal/user-agreement"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                terms
              </Link>
              ,{" "}
              <Link
                href="https://www.linkedin.com/legal/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                privacy policy
              </Link>{" "}
              and{" "}
              <Link
                href="https://www.linkedin.com/legal/cookie-policy"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                cookie policies
              </Link>
              .
            </Typography>
            <h5>How We Use Your Information</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We will only use information that we collect about you or that you
              provide to us, including any personal information for purposes
              described in this privacy policy and when applicable law allows us
              to do so. We will generally use your information on the following
              legal grounds:
            </Typography>
            <ul style={{ marginLeft: "2rem" }}>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Where the use is necessary for the purposes of our legitimate
                  interests (or those of a third party);
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Where we need to comply with a legal or regulatory obligation;
                  or
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Where you have given your consent (which can be withdrawn at
                  any time).
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" color="text.primary" paragraph>
              We use information that we collect about you or that you provide
              to us, including any personal information:
            </Typography>
            <ul style={{ marginLeft: "2rem" }}>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To provide access and use of the {seniorlivingName} Platform.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To provide you the Site and the other {seniorlivingName}{" "}
                  Services and the content that is on it.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To verify your identity and prevent fraud or other
                  unauthorized or illegal activity.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To comply with applicable legal and regulatory requirements,
                  including “know your customer” and “anti-money laundering”
                  requirements.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To provide technical and other support to you.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To fulfill any other purpose for which you provide it.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To carry out our obligations and enforce our rights arising
                  from any contracts entered into between you and us, including
                  for billing and collection.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  To enhance the safety and security of all of the{" "}
                  {seniorlivingName}
                  Services.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  In any other way we may describe when you provide the
                  information.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  For any other purpose with your consent.
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" color="text.primary" paragraph>
              Some of the information that we collect automatically may be
              statistical data and does not include personal information, but we
              may maintain it or associate it with personal information we
              collect in other ways or receive from third parties or you provide
              to us. It helps us to improve the Site and the other{" "}
              {seniorlivingName}
              Services, and to deliver a better and more personalized service,
              including enabling us to:
            </Typography>
            <ul style={{ marginLeft: "2rem" }}>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Optimize the platform and services
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Estimate our audience size and better understand usage
                  patterns.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  Recognize you when you return to the site.
                </Typography>
              </li>
            </ul>
            <h5>Storage and Transfer of Your Information</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We may store any data or other information that we collect
              (personal or otherwise) ourselves or in databases and servers
              owned and maintained by us, our affiliates, agents or Service
              Providers. If you access or use the site or any of the other
              {seniorlivingName} Services outside of the United States,
              information that we collect about you may be transferred to
              servers inside the United States and maintained indefinitely,
              which may involve the transfer of information out of countries
              located in the European Economic Area and other parts of the world
              unless otherwise prohibited by applicable law or agreed by{" "}
              {seniorlivingName} and you. By allowing {seniorlivingName} to
              collect information about you, you consent to such transfer and
              processing of such information without restriction. We may also
              store some information locally on your computer or other devices.
              For example, we may store information as local cache so that you
              can open the site and view content faster.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              Although users from all over the world may access the site, keep
              in mind that no matter where you live or where you happen to use
              our services, you consent to us processing and transferring
              information in and to the United States and other countries whose
              data-protection and privacy laws may offer fewer protections than
              those in your home country.
            </Typography>
            <h5>Anonymized or Aggregated Information.</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We may use information that is anonymized or in an aggregated form
              to improve {seniorlivingName} Services and for other internal
              business purposes without restriction.
            </Typography>
            <h5>
              Choices About How We Use and Disclose Your Personal information
            </h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We strive to provide you with choices regarding the personal
              information you provide to us. We have created mechanisms to
              provide you with the following control over your personal
              information:
            </Typography>
            <ul style={{ marginLeft: "2rem" }}>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  <span style={{ textDecoration: "underline" }}>
                    <strong>Tracking Technologies and Advertising.</strong>
                  </span>{" "}
                  You can set your browser to refuse all or some browser
                  cookies, or to alert you when cookies are being sent. To learn
                  how you can manage your Flash cookie settings, visit the Flash
                  Player settings page on{" "}
                  <Link
                    href="https://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="primary"
                  >
                    Adobe’s website
                  </Link>
                  . If you disable or refuse cookies, please note that all or
                  some parts of the {seniorlivingName} Services may then be
                  inaccessible or not function properly.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="body1"
                  color="text.primary"
                  component="span"
                >
                  <span style={{ textDecoration: "underline" }}>
                    <strong>Promotional Offers from {seniorlivingName}.</strong>
                  </span>{" "}
                   If you do not wish to have your email address/contact
                  information used by {seniorlivingName} to market or otherwise
                  promote our own or third parties’ products or services, you
                  can opt-out through the unsubscribe mechanism at the bottom of
                  the applicable email. This opt-out does not apply to
                  information provided to {seniorlivingName} as a result of a
                  service or product purchase, product service experience or
                  other transactions.
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" color="text.primary" paragraph>
              We do not control third parties’ collection or use of your
              information to serve interest-based advertising. You may be able
              to opt out of receiving personalized advertisements from companies
              who are members of the Network Advertising Initiative or who
              subscribe to the Digital Advertising Alliance’s Self-Regulatory
              Principles for Online Behavioral Advertising. For more information
              about this practice and to understand your options, please visit:{" "}
              <Link
                href="http://www.aboutads.info"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                www.aboutads.info
              </Link>{" "}
              and{" "}
              <Link
                href="http://www.networkadvertising.org/choices/"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                www.networkadvertising.org/choices/
              </Link>
              . You may also use TRUSTe’s Preference Manager at{" "}
              <Link
                href="http://preferences-mgr.truste.com"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                preferences-mgr.truste.com
              </Link>
              .
            </Typography>
            <h5>Accessing and Correcting Your Personal information</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              You may change, correct or delete any personal information that
              you have provided to us through your account settings or donor
              profile or by emailing us.
            </Typography>
            <h5>Your California Privacy Rights</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              California Civil Code Section § 1798.83 permits users of the site
              that are California residents to request certain information
              regarding our disclosure of personal information to third parties
              for their direct marketing purposes.
            </Typography>
            <h5>How Long We Store Your Personal information</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We will only retain the personal information of Organizations and
              Donors, in a form which permits us to identify you, for as long as
              your account is active or for as long as required for compliance
              or legal purposes. We will retain and use your personal
              information as necessary to satisfy any legal, accounting or
              reporting requirements, to resolve disputes or to enforce our
              agreements and rights. Subject to the foregoing, we will delete
              your personal information upon your request except to the extent
              that we are required by applicable law or regulation to retain
              such information. To dispose of personal information, we may
              anonymize it, delete it or take other appropriate steps. Data may
              persist in copies made for backup and business continuity purposes
              for additional time.
            </Typography>
            <h5>Information Security</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              We understand that the security of your personal information is
              important. We provide reasonable administrative, technical, and
              physical security controls to protect your personal information.
              However, despite our efforts, no security controls are 100%
              effective. {seniorlivingName} cannot ensure or warrant the
              security of your personal information. Any transmission of
              personal information is at your own risk. We are not responsible
              for circumvention of any privacy settings or security measures
              contained on the Site or the other {seniorlivingName} Services.
            </Typography>
            <Typography variant="body1" color="text.primary" paragraph>
              The safety and security of your data also depends on you. Where
              you have chosen (or we have given you) a password for access to
              and use of your account, you are responsible for keeping this
              password confidential. We ask you not to share your password with
              anyone.
            </Typography>
            <h5>Changes to Our Privacy Policy</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              It is our policy to post any changes we make to our privacy policy
              on this page with a notice that the privacy policy has been
              updated on the home pages of the site for at least 30 days. If we
              make material changes to how we treat our users’ personal
              information that are materially less protective than provided in
              this policy, we will use reasonable efforts to notify you by email
              to the email address specified in your account and/or through a
              notice on the home pages of the site and to attempt to get your
              consent to the changes. The date the privacy policy was last
              updated is identified above. You are responsible for ensuring that
              we have an up-to-date active and deliverable email address for
              you, and for periodically visiting the site and this privacy
              policy to check for any changes. Like our Terms, of which this
              privacy policy is a part, your continued use, and/or continued use
              after our efforts to contact you, of the Fundraising Services, the
              site or any of the other {seniorlivingName} Services, means that
              you agree to be bound by such changes.
            </Typography>
            <h5>Survival</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              The policies indicated in this privacy policy will remain
              effective, even if the Terms and the other agreements between us
              are terminated and you are no longer using the Fundraising
              Services, the site or any of the other {seniorlivingName}{" "}
              Services.
            </Typography>

            <h5>Contact Information</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              {seniorlivingName} welcomes your questions or comments regarding
              this Statement of Privacy. If you believe that {seniorlivingName}{" "}
              has not adhered to this Statement, please contact {restaurantName}{" "}
              at:
              <br />
              <strong>Address: </strong>
              <span style={{ textDecoration: "underline" }}>
                <a href={googleMaps} class="f-link" target="_blank">
                  {restaurantAddress}{" "}
                </a>
              </span>
              <br />
              <strong>Telephone number: </strong>
              <span style={{ textDecoration: "underline" }}>
                <a href={`tel:${phoneNumber}`}>{phoneNumber} </a>
                {/* Email Address: <a href={`mailto:${emailAddress}`}>{emailAddress}</a> */}
              </span>
            </Typography>
          </Col>
          <col className="whitespace"></col>
        </Row>
      </Container>
      {enableSL == 1 ? (
        <BottomCheckOutNav
          sx={{
            backgroundColor: "transparent",
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        />
      ) : null}
    </div>
  );
};
